import { make } from 'vuex-pathify'
import api from '@/plugins/api'
import assetUrl from '@/tools/assetUrl'

const state = {
    id: null,
    name: null,
    username: null,
    email: null,
    university: null,
    image: null,
    contact: null,
    role: null,
    token: null,
    is_authenticated: false,
    group_hash: null,
    is_group_active: null,
}

const getters = {
    isAuthenticated(state) {
        return state.is_authenticated
    },

    image(state) {
        return state.image ? assetUrl(state.image) : null
    }
}

const actions = {
    presistToken({ state }) {
        if (state.token) {
            localStorage.setItem('token', state.token)
        } else {
            localStorage.removeItem('token')
        }
    },

    signup({ commit, dispatch }, context) {
        const endpoint = context.endpoint ? context.endpoint : 'auth/signup'

        return new Promise((resolve, reject) => {
            api.post(endpoint, context.data, { loader: 'signup' })
                .then(response => {
                    commit('SET_TOKEN', response.data.token)
                    dispatch('presistToken')
                    window._paq.push(['trackEvent', 'Akun', 'Daftar'])

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    login({ commit, dispatch }, context) {
        return new Promise((resolve, reject) => {
            api.post('auth/login', context.data, { loader: 'login', noErrorRedirection: context.noErrorRedirection == true })
                .then(response => {
                    window._paq.push(['setUserId', response.data.id])
                    window._paq.push(['trackEvent', 'Akun', 'Masuk'])
                    commit('SET_TOKEN', response.data.token)
                    dispatch('presistToken')

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    setDataFromAuth({ commit }, data) {
        window._paq.push(['setUserId', data.id])
        commit('SET_ID', data.id)
        commit('SET_NAME', data.name)
        commit('SET_USERNAME', data.username)
        commit('SET_EMAIL', data.email)
        commit('SET_UNIVERSITY', data.university)
        commit('SET_IMAGE', data.image)
        commit('SET_ROLE', data.role)
        commit('SET_IS_AUTHENTICATED', true)
        commit('SET_GROUP_HASH', data.group_hash)
        commit('SET_IS_GROUP_ACTIVE', data.is_group_active)
    },

    unsetData({ commit }) {
        commit('SET_TOKEN', null)
        commit('SET_IS_AUTHENTICATED', false)
        commit('enrollment/SET_ENROLLMENTS', null, { root: true })
        commit('enrollment/SET_SELECTED_IDX', null, { root: true })

        localStorage.removeItem('token')
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations: make.mutations(state),
    actions
}
